import React from "react";
import moment from "moment";
import { ControlLabel } from "react-bootstrap";

export default class RequestActivityList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
       return(
            <div className="ap-request-step">
                <ul>
                    {
                        this.props.data.map(function(item, i) {
                            if (item.modifyDate != null) {
                                return <li className="passed">
                                    <div>
                                        <ControlLabel className="ap-report-control-label ap-black-color">{item.statusDescription}</ControlLabel>
                                        <ControlLabel className="ap-report-control-label ap-5-margin-left">{'on ' + moment(item.modifyDate).format("MM/DD/YYYY")}</ControlLabel>
                                    </div>
                                </li>
                            }
                            else {
                                return <li>
                                    <div>
                                        <ControlLabel className="ap-report-control-label">{item.statusDescription}</ControlLabel>
                                    </div>
                                </li>
                            }
                        })
                    }
                </ul>
            </div>
        );
    }
}